export const MAX_BUFFERED_ANALYTICS_EVENTS = 360;

export const bufferAnalyticsEvent = (buffer, event) => {
  if (buffer.length >= MAX_BUFFERED_ANALYTICS_EVENTS) {
    buffer.shift();
  }

  buffer.push(event);
};

export const drainAnalyticsEvents = (buffer, sendEvent) => {
  buffer.splice(0).forEach(event => sendEvent(event));
};

export const getFirebaseInstallationId = async installations => {
  try {
    return await installations.getId();
  } catch (error) {
    console.warn(
      '[Firebase] Installation ID unavailable; continuing without it.',
      error,
    );
    return undefined;
  }
};
